import React, { FC, useEffect, useState } from 'react';
import { font as initialFont } from '@styles/fonts';
import { scale as initialScale } from '@components/frame';
import { useSetInterval } from '@v2/pages/common/hooks/useSetInterval';
import TimeDisplay, { TimeDisplayProps } from '@components/common/TimeDisplay';

export interface TimeDisplayInStaticFormatProps extends Omit<TimeDisplayProps, 'value'> {
  timeValue: number;
  shouldRunTime?: boolean;
}

const TimeDisplayInStaticFormat: FC<TimeDisplayInStaticFormatProps> = ({
  timeValue,
  shouldRunTime,
  color = 'Label/Light/Tertiary',
  withHMSFormat = true,
  fontForDigit = 'Time 3',
  fontForSecondDigit = 'Time 4',
  fontForSecondLetter = 'Caption 2',
  scale = initialScale,
  font = initialFont,
  ...rest
}) => {
  const [value, setValue] = useState<number>(timeValue);

  useEffect(() => {
    setValue(timeValue);
  }, [timeValue]);

  useSetInterval({
    disabled: !shouldRunTime || timeValue >= 60 * 60 * 100,
    action: () => setValue((prev) => prev + 1),
    dependencyArray: [shouldRunTime],
  });

  return (
    <TimeDisplay
      value={value}
      scale={scale}
      font={font}
      color={color}
      withHMSFormat={withHMSFormat}
      fontForDigit={fontForDigit}
      fontForSecondDigit={fontForSecondDigit}
      fontForSecondLetter={fontForSecondLetter}
      {...rest}
    />
  );
};

export default TimeDisplayInStaticFormat;
